import {
  LIBRARY_TAXES_PAGE_REQUEST,
  LIBRARY_TAXES_LIST_REQUEST,
  LIBRARY_TAXES_SET_LIST_TAXES,
  LIBRARY_TAXES_ON_CHANGE_OUTLET_IDS,
  LIBRARY_TAXES_SET_OUTLETS,
  LIBRARY_TAXES_ON_CLICK_CREATE_TAX,
  LIBRARY_TAXES_SET_CURRENT_PAGE,
  LIBRARY_TAXES_SET_TOTAL_PAGE,
  LIBRARY_TAXES_ON_CLICK_ROW,
  LIBRARY_TAXES_SET_TAX_DETAIL,
  LIBRARY_TAXES_ON_CLICK_CANCEL,
  LIBRARY_TAXES_SUBMIT_FORM_UPDATE,
  LIBRARY_TAXES_SUBMIT_FORM_CREATE,
  LIBRARY_TAXES_DELETE_TAX_REQUEST,
  LIBRARY_TAXES_SHOW_DELETE_MODAL,
  LIBRARY_TAXES_HIDE_DELETE_MODAL,
  LIBRARY_TAXES_CANCEL_DELETE,
  LIBRARY_TAXES_DELETE_TAX,
  LIBRARY_TAXES_SET_DELETED_TAX,
  LIBRARY_TAXES_SUBMIT_FORM_CREATE_ALL_OUTLETS,
  LIBRARY_TAXES_CLOSE_RIGHT_COLUMN,
  LIBRARY_TAXES_OPEN_RIGHT_COLUMN,
  LIBRARY_TAXES_IS_SUBMITTING_FORM,
} from './constants';

export function taxesPageRequest() {
  return { type: LIBRARY_TAXES_PAGE_REQUEST, payload: {} };
}

export function taxesRequest(params, previousTaxes) {
  return {
    type: LIBRARY_TAXES_LIST_REQUEST,
    payload: { params, previousTaxes },
  };
}

export function setListTaxes(taxes) {
  return { type: LIBRARY_TAXES_SET_LIST_TAXES, payload: { taxes } };
}

export function onChangeOutletIds(outletIds) {
  return {
    type: LIBRARY_TAXES_ON_CHANGE_OUTLET_IDS,
    payload: { outletIds },
  };
}

export function setOutlets(outlets) {
  return { type: LIBRARY_TAXES_SET_OUTLETS, payload: { outlets } };
}

export function setCurrentPage(currentPage) {
  return { type: LIBRARY_TAXES_SET_CURRENT_PAGE, payload: { currentPage } };
}

export function setTotalPage(totalPage) {
  return { type: LIBRARY_TAXES_SET_TOTAL_PAGE, payload: { totalPage } };
}

export function onClickCreateTax() {
  return { type: LIBRARY_TAXES_ON_CLICK_CREATE_TAX, payload: {} };
}

export function onClickRow(tax) {
  return { type: LIBRARY_TAXES_ON_CLICK_ROW, payload: { tax } };
}

export function setTaxDetail(tax) {
  return { type: LIBRARY_TAXES_SET_TAX_DETAIL, payload: { tax } };
}

export function onClickCancel() {
  return { type: LIBRARY_TAXES_ON_CLICK_CANCEL, payload: {} };
}

export function submitFormUpdate(id, data, previousTaxes) {
  return {
    type: LIBRARY_TAXES_SUBMIT_FORM_UPDATE,
    payload: { id, data, previousTaxes },
  };
}

export function submitFormCreate(data, previousTaxes) {
  return {
    type: LIBRARY_TAXES_SUBMIT_FORM_CREATE,
    payload: { data, previousTaxes },
  };
}

export function setDeletedTax(deletedTax) {
  return { type: LIBRARY_TAXES_SET_DELETED_TAX, payload: { deletedTax } };
}

export function deleteTaxRequest(deletedTax) {
  return { type: LIBRARY_TAXES_DELETE_TAX_REQUEST, payload: { deletedTax } };
}

export function showDeleteModal() {
  return { type: LIBRARY_TAXES_SHOW_DELETE_MODAL, payload: {} };
}

export function hideDeleteModal() {
  return { type: LIBRARY_TAXES_HIDE_DELETE_MODAL, payload: {} };
}

export function cancelDelete() {
  return { type: LIBRARY_TAXES_CANCEL_DELETE, payload: {} };
}

export function deleteTax(id, previousTaxes) {
  return { type: LIBRARY_TAXES_DELETE_TAX, payload: { id, previousTaxes } };
}

export function submitFormCreateAllOutlets(data, previousTaxes) {
  return {
    type: LIBRARY_TAXES_SUBMIT_FORM_CREATE_ALL_OUTLETS,
    payload: { data, previousTaxes },
  };
}

export function openRightColumn() {
  return { type: LIBRARY_TAXES_OPEN_RIGHT_COLUMN, payload: {} };
}

export function closeRightColumn() {
  return { type: LIBRARY_TAXES_CLOSE_RIGHT_COLUMN, payload: {} };
}

export function isSubmittingForm(isSubmittingFormPayload) {
  return {
    type: LIBRARY_TAXES_IS_SUBMITTING_FORM,
    payload: { isSubmittingForm: isSubmittingFormPayload },
  };
}
